import React, { useContext } from 'react';
import {
    Box,
    Card,
    CardActionArea,
    CardContent,
    CardMedia,
    Typography,
} from '@mui/material';
import { useCol } from '../hooks';
import '../style/list-screen.scss';
import { FieldContext } from '../App';

export const ListScreen = ({ setSelectedTab }) => {
    const { setFieldId } = useContext(FieldContext);
    const { data } = useCol('fields');

    console.log(data)

    return (
        <Box overflow="scroll" className="containerBox">
            <Box width="80vw" display="flex" flexWrap="wrap">
                {data &&
                    data.map((item, index) => (
                        <Card
                            onClick={() => {
                                setSelectedTab('Field-details');
                                setFieldId(item.id);
                            }}
                            key={`field-${index}`}
                            className="zaal-card"
                        >
                            <CardActionArea>
                                <CardMedia
                                    className="zaal-card-image"
                                    image={`${item.posters[0]}`}
                                />
                                <CardContent>
                                    <Typography
                                        gutterBottom
                                        variant="h5"
                                        component="h2"
                                    >
                                        {item.name}
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        color="textSecondary"
                                        component="p"
                                    >
                                        Байршил: {item.locations}
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        color="textSecondary"
                                        component="p"
                                    >
                                        Үнэ: {item.price.fullPrice}
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        color="textSecondary"
                                        component="p"
                                    >
                                        Цаг: {item.timeTable.open} -{' '}
                                        {item.timeTable.close}
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    ))}
            </Box>
        </Box>
    );
};
